export const roleMapping: { [key: string]: string } = {
  0: 'User',
  1: 'Organization Admin',
  2: 'Platform Admin',
};

// Import from centralized file type configuration
export { sampleFileExtensions } from './config/sampleFileTypes';

export const LSM_PIPELINE_NAME = 'lsm-inference-pipeline';

import { ConfigEditorValues } from './interfaces/job';
export const defaultConfigEditorValues: ConfigEditorValues = {
  mode: 'standard',
  selectedModel: null,
  analyteSets: [],
  restrictedAnalyteSets: [],
  qcAnalyteSets: [],
  restrictedQcAnalyteSets: [],
  selectedIdModel: null,
  selectedQuantModel: null,
  mzWindowPpm: '4',
  poolsAlignmentEnabled: false,
  poolsAlignmentAligner: 'naive_gap_fill',
  poolsAlignmentXic: 'windowed_trapz',
  poolsAlignmentDebug: false,
};
